module.exports = __webpack_public_path__ + "static/img/admin.812fcab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/admin.jpg
// module id = nRLm
// module chunks = 81